module.exports = __webpack_public_path__ + "static/img/interturis-1.9074710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/interturis-1.jpg
// module id = rtAg
// module chunks = 1